import { css, cx } from "@emotion/css"

import { CellProps } from "react-table"
import { MediaItem } from "models/common"
import { format as moneyFormat } from "utils/currencies"
import { useAuthenticated } from "providers/A12n"
import { useI18n } from "providers/I18n"

export const variants: Record<string, any> = {
  default: "",
  numeric: css`
    text-align: right;
  `,
  cell: css`
    font-size: 0.8125rem;
    color: var(--black);
    padding: 0;
    font-weight: normal;
    input[type="text"] {
      font-size: 0.8125rem;
    }
    fieldset {
      border: none;
    }
  `,
  customInput: css`
    font-size: 0.8125rem;
    padding: 4px;
    border: none;
    &:hover {
      padding: 3px;
      border: 1px dashed var(--primary-main);
    }
    input,
    input[type="text"] {
      padding: 0;
      text-align: end;
    }
    fieldset {
      border: 0;
    }
  `,
  dropicon: css`
    font-size: 0.8125rem;
  `,
}

export function HeaderCell(props: any) {
  const { column } = props
  const { t } = useI18n()
  const { variant = "", header = "" } = column
  return <div className={variants[variant as string]}>{t(header)}</div>
}

export function BudgetCell<D extends MediaItem>(props: CellProps<D, number>) {
  const { budget, currencyCode } = props.row.original
  return !budget || !currencyCode ? (
    " - "
  ) : (
    <div className={cx("BodyBody-2BlackRegular", variants.numeric)}>
      {budget ? moneyFormat(budget, currencyCode) : " - "}
    </div>
  )
}

export function ExchangeRateAdjustedBudgetCell<D extends MediaItem>(
  props: CellProps<D, number>,
) {
  const { exchangeRateAdjustedBudget, campaignCurrency } = props.row.original
  return !exchangeRateAdjustedBudget || !campaignCurrency ? (
    " - "
  ) : (
    <div className={cx("BodyBody-2BlackRegular", variants.numeric)}>
      {exchangeRateAdjustedBudget
        ? moneyFormat(exchangeRateAdjustedBudget, campaignCurrency)
        : " - "}
    </div>
  )
}

export function InvoicedCell<D extends MediaItem>(props: CellProps<D, number>) {
  const { invoicedAmount, currencyCode } = props.row.original
  return (
    <div className={cx("BodyBody-2BlackRegular", variants.numeric)}>
      {invoicedAmount ? moneyFormat(invoicedAmount, currencyCode) : " - "}
    </div>
  )
}

export function DateCell<D extends object>(
  props: CellProps<D, string | number | Date>,
) {
  const { dateFormatter } = useAuthenticated()
  const { value } = props
  if (value === null) return null
  return (
    <div className={cx("BodyBody-2BlackRegular", variants.numeric)}>
      {dateFormatter(value)}
    </div>
  )
}
